export interface EditorMenuSlashItem {
  id: string;
  label: string;
}

interface EditorMenuPopoverProps {
  x: number;
  y: number;
  activeIndex: number;
  items: EditorMenuSlashItem[];
  testIdPrefix?: string;
  onSelect: (index: number) => void;
}

export function EditorMenuPopover({
  x,
  y,
  activeIndex,
  items,
  testIdPrefix,
  onSelect
}: EditorMenuPopoverProps) {
  const tid = (suffix: string) =>
    testIdPrefix ? `${testIdPrefix}-${suffix}` : undefined;

  return (
    <div
      data-menu-pop
      className="pn-markdown-editor-menu"
      style={{ left: x, top: y }}
      role="listbox"
      data-testid={tid('slash-menu')}
    >
      <div className="pn-markdown-editor-menu-hd">Insert</div>
      {items.length === 0 ? (
        <div className="pn-markdown-editor-menu-empty">No matches</div>
      ) : (
        items.map((item, i) => (
          <button
            type="button"
            key={item.id}
            className="pn-markdown-editor-menu-item"
            data-active={i === activeIndex ? 'true' : 'false'}
            data-testid={tid(`slash-item-${item.id}`)}
            onMouseDown={(e) => {
              e.preventDefault();
              onSelect(i);
            }}
          >
            {item.label}
          </button>
        ))
      )}
    </div>
  );
}
